// denominator_unit_id of a transport emission factor given per km.
// Not an indicator denominator, so it stays out of the `Denominator` enum.
export const KILOMETER_DENOMINATOR_UNIT_ID = 12;

type FactorUnit = {
  denominatorUnit?: { id?: number | null } | null;
};

type FactorWithEmission = FactorUnit & {
  emission: number;
};

export function isKilometerFactor(factor: FactorUnit | null | undefined): boolean {
  return factor?.denominatorUnit?.id === KILOMETER_DENOMINATOR_UNIT_ID;
}

// Emission for one unit typed into the factor's input: a km is km × weight (kg) × emission.
export function emissionPerInputUnit(factor: FactorWithEmission, weightKg: number): number {
  return isKilometerFactor(factor) ? factor.emission * weightKg : factor.emission;
}

// The value a factor's input shows for a given total; 0 where the factor gives no emission.
export function inputValueForTotal(total: number, factor: FactorWithEmission, weightKg: number): number {
  const value = total / emissionPerInputUnit(factor, weightKg);
  return Number.isFinite(value) ? value : 0;
}
